import React from "react";
import { Box } from "@mui/material";
import Title from "./Title";
import Sentence from "./Sentence";

const Introduction = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ backgroundColor: "#fbf9f3" }} // 背景を白に設定
    >
      <Box
        sx={{
          padding: 4,
          display: "inline-block", // コンテンツに合わせて横幅を調整
          textAlign: "center",
          margin: "0 auto", // 親Boxを中央寄せ
        }}
      >
        {/* CustomTypographyWithUnderline を使ってタイトルを表示 */}
        <Title>Introduction</Title>

        <Box sx={{ p: 2 }}></Box>
        <Sentence>謹啓 初夏の候</Sentence>
        <Sentence>
          皆様いかがお過ごしでしょうか
          <br />
          このたび私たちふたりは
          <br />
          結婚式を挙げることとなりました
          <br />
          つきましては 日頃お世話になっている
          <br />
          皆さまに 感謝の気持ちを込めて
          <br />
          ささやかな小宴を催したいと存じます
        </Sentence>
        <Sentence>
          ご多用のところ 誠に恐れ入りますが
          <br />
          ぜひご出席くださいますようご案内申し上げます
          <br />
          謹白
        </Sentence>
        <Sentence>
          令和7年6月 吉日
          <br />
          中島 輝征 ・ 玲乃
        </Sentence>
      </Box>
    </Box>
  );
};

export default Introduction;
